import React from "react";
import styles from "./style.module.scss";

type SkipLinkProps = {
  target: string;
  text: string;
};

const SkipNavigation = ({ target, text }: SkipLinkProps) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const targetElement = document.getElementById(target);

    if (!targetElement) {
      return;
    }

    event.preventDefault();
    targetElement.focus();
  };

  return (
    <div className={styles.skipLinkContainer}>
      <a className={styles.skipLink} href={`#${target}`} onClick={handleClick}>
        {text}
      </a>
    </div>
  );
};

export default SkipNavigation;
